import { createReducer, on } from '@ngrx/store';
import {
	initialPermissionsState,
	PermissionsState,
} from './permissions.interface';
import * as PermissionsActions from './permissions.actions';
import * as AuthActions from '../auth/auth.actions';

export const permissionsReducer = createReducer(
	initialPermissionsState,

	on(
		PermissionsActions.fetchPermissions,
		(state): PermissionsState => ({
			...state,
			loading: true,
			error: null,
		})
	),

	on(
		PermissionsActions.fetchPermissionsSuccess,
		(state, { permissions }): PermissionsState => ({
			...state,
			permissions: permissions,
			loading: false,
			error: null,
		})
	),

	on(
		PermissionsActions.fetchPermissionsFailure,
		(state, { error }): PermissionsState => ({
			...state,
			loading: false,
			error,
		})
	),

	on(
		PermissionsActions.clearPermissions,
		(state): PermissionsState => ({
			...state,
			permissions: null,
			loading: false,
			error: null,
		})
	),

	// Listen to Auth logout - immediately reset permissions state
	on(
		AuthActions.logout,
		(): PermissionsState => ({
			...initialPermissionsState,
		})
	)
);
